var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pdf"},[_vm._l((_vm.configuration.data.pages),function(page,index){return [_c('div',{staticClass:"page oh"},[_c('img',{attrs:{"src":page}})]),_c('div',{staticClass:"flex flex-center page-number"},[_c('div',{staticClass:"badge"},[_vm._v("Page "+_vm._s(index + 1))])])]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }